import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import{ convertStringToElements }from "@vds/html-parsers";

import { setA11yContent } from "../NavigationHelper/actions";
import { checkNestedObject } from "utils/checkNestedObject";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";

import Header from "common-components/Header";
import StyledLink from "common-components/StyledLink";
import Container from "common-components/Container";

import FetchPageContent from "../../../hoc/FetchPageContent";
import { PendingAuthorizedAgentModal } from "./ManageAuthorizedAgent";

class AssignAgentInformation extends Component {
  state = {
    showPendingModal: false
  };

  componentDidMount() {
    if (checkNestedObject(this.props.breadCrumbs, "landingPage")) {
      const { landingPage, agentInformation } = this.props.breadCrumbs;

      this.props.setBreadcrumbList([
        { label: landingPage, path: "/privacy/secure/your-data" },
        { label: agentInformation, path: "/privacy/secure/your-data/authorized-agent/information" }
      ]);
    }

    if (this.props.agentDetails[0] && this.props.agentDetails[0].status === "IN_PROGRESS") {
      this.setState({ showPendingModal: true });
    } else {
      if (checkNestedObject(this.props.pageContent, "sc_pagetitle")) {
        this.props.setA11yContent("authorized agent information", this.props.pageContent.sc_pagetitle);
      }
    }
  }

  checkForAuthAgent = () => {
    const {
      agentDetails: [agentDetails]
    } = this.props;

    if (agentDetails && agentDetails.agentRegId && agentDetails.status.toUpperCase() !== "NOT APPROVED") {
      return "/privacy/secure/your-data/authorized-agent/manage";
    }
    return "/privacy/secure/your-data/authorized-agent/assign";
  };

  render() {
    const { section_title, icontexts, buttons } = this.props.pageContent;
    const { modalContent } = this.props;

    return (
      <Container>
        {this.state.showPendingModal ? (
          <PendingAuthorizedAgentModal
            modalContent={modalContent}
            handleClick={() => this.props.history.goBack()}
            visibleModal
          />
        ) : null}
        <Header>{section_title}</Header>
        {icontexts.length
          ? icontexts.map(item => (                                       
            <Div key={item.text}>
              {/* {convertStringToElements(item.icon)} */}
              {convertStringToElements(item.text)}
            </Div>
          ))
          : null}
        <StyledLink data-testId={"continueButton"} background={buttons[0].type} style={{ marginTop: "16px" }} to={this.checkForAuthAgent()}>
          {buttons[0].text}
        </StyledLink>
      </Container>
    );
  }
}

const mapStateToProps = ({
  pageContent: { assign_agent_information: pageContent, pending_auth_agent_modal: modalContent, breadCrumbs },
  downloadAndDelete: { agentDetailsData: agentDetails }
}) => ({
  pageContent,
  modalContent,
  agentDetails,
  breadCrumbs
});

export default compose(
  connect(
    mapStateToProps,
    { setA11yContent, setBreadcrumbList }
  ),
  FetchPageContent
)(AssignAgentInformation);

const Div = styled.div`
  margin: 40px 0;

  h2 {
    font-size: 20px;
    line-height: 19px;
  }

  p {
    margin: 12px 0;
    max-width: 600px;
  }

  p strong {
    font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
    font-weight: 700;
  }

  ul {
    list-style: disc inside;
    margin: 15px 0;

    li {
      max-width: 530px;
      list-style-position: outside;
    }
  }
`;
